<button (click)="setStatic()">SetStatic</button>

